import { Listbox } from '@headlessui/react';
import type { Dispatch, MouseEvent, SetStateAction } from 'react';

import { ReactComponent as ArrowDownIcon } from 'assets/icons/sz/arrow-down.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/sz/trash-icon.svg';
import { useTranslate } from 'hooks';
import { renderIcon, twMergeClsx } from 'utils';

type CardOptionType = {
  crypt?: string;
  maskedPan: string;
  bankBin?: string;
  newCard?: boolean;
  id: number;
};

const SelectCard = ({
  selectedCard,
  cards,
  handleDelete,
  setSelectedCard,
}: {
  cards: CardOptionType[];
  selectedCard: CardOptionType;
  handleDelete: (value: string) => void;
  setSelectedCard: Dispatch<SetStateAction<CardOptionType>>;
}) => {
  const { t } = useTranslate();

  const defaulValue = { maskedPan: t('betCity.new-bank-card'), newCard: true };
  const renderBtnContent = () => {
    if (selectedCard) {
      if (selectedCard.newCard) {
        return <span className="flex-grow">{selectedCard.maskedPan}</span>;
      }

      return selectedCard.bankBin ? (
        <>
          {renderIcon(selectedCard.bankBin)}
          <span className="flex-grow">{selectedCard.maskedPan}</span>
        </>
      ) : null;
    }

    return null;
  };

  const deleteCard = (e: MouseEvent<HTMLButtonElement>, pan: string) => {
    handleDelete(pan);
    e.stopPropagation();
  };

  return (
    <Listbox as="div" className="relative" value={selectedCard} onChange={setSelectedCard}>
      {({ open }) => (
        <>
          <Listbox.Button className="z-10 flex items-center gap-[10px] relative px-4 py-[6px] md:py-3 w-full text-left bg-white outline-none h-[42px] md:h-[50px] rounded-xsmall text-base md:text-xl text-black leading-[30px] border border-solid border-black">
            {renderBtnContent()}
            <ArrowDownIcon
              className={twMergeClsx(
                'w-5 h-5 transition-transform fill-1xbet-black',
                open && 'rotate-180',
              )}
            />
          </Listbox.Button>
          <Listbox.Options className="absolute border border-solid border-black w-full z-50 rounded-xsmall mt-1 text-base md:text-xl text-black overflow-hidden">
            <Listbox.Option
              className="px-4 py-[6px] h-[42px] md:h-[50px] md:py-3 border-b border-black bg-white last:border-none cursor-pointer transition-colors"
              value={defaulValue}
            >
              {defaulValue.maskedPan}
            </Listbox.Option>
            {cards?.map((item) => (
              <Listbox.Option
                className="px-4 py-[6px] h-[42px] md:h-[50px] md:py-3 border-b border-black bg-white last:border-none cursor-pointer transition-colors flex items-center gap-[10px]"
                value={item}
                key={item.maskedPan}
              >
                {item.bankBin && renderIcon(item.bankBin)}
                <span className="flex-grow">{item.maskedPan}</span>
                <button
                  className="w-6 h-6"
                  type="button"
                  onClick={(e) => deleteCard(e, item.maskedPan)}
                >
                  <TrashIcon className="fill-1xbet-black" />
                </button>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </>
      )}
    </Listbox>
  );
};

export { SelectCard };
